import { RivalsAppProps, RivalsPageProps } from "rivals/Context";
import Futurecasts from "rivals/components/pages/Futurecast";
import { getForecasters, getForecasts } from "rivals/redux/futurecast/actions";
import { getRailsConstants } from "rivals/redux/rails/actions";
import { RailsConstantsKeys } from "rivals/redux/rails/reducer";

function FuturecastPage(): JSX.Element {
  return (
    <main role="main">
      <Futurecasts />
    </main>
  );
}

FuturecastPage.getInitialProps = async ({
  isServer,
  store: { dispatch }
}: RivalsAppProps): Promise<RivalsPageProps> => {
  dispatch(getRailsConstants([RailsConstantsKeys.ADS_SETTINGS]));
  dispatch(getForecasters());
  dispatch(getForecasts());

  return { isServer };
};

export default FuturecastPage;
